import React from 'react';
import {
  MediaOriginatorType,
} from 'pages/Dashboard/utils/constants';
import ProfilePictureDialog from 'views/EMR/components/ProfilePictureDialog';

type Props = {
  userId: number;
  onClose: () => void;
};

export default function UserProfilePictureDialog({
  userId,
  onClose,
}: Props) {
  return (
    <ProfilePictureDialog
      entityId={userId}
      originatorType={MediaOriginatorType.User}
      onClose={onClose}
    />
  );
}
